import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import { useMemo } from 'react';
import { ContextItemType } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
import { UserRecentFeature } from 'src/generated/graphql';
import { useUserRecents } from 'src/hooks/recents';
import { NavRecentItemIcon } from 'src/layouts/DashboardLayout/NavRecents/NavRecentItemIcon';
import { useLocales } from 'src/locales';
import type { AIInputStateControl } from '../useAIInputState';

export const AiContextRecentLists = ({
  control,
}: {
  control: AIInputStateControl;
}) => {
  const { allRecents } = useUserRecents();
  const { translate } = useLocales();
  const { toggle, hasContextFile, currentDocument } = control((s) => ({
    toggle: s.toggleContextFiles,
    hasContextFile: s.hasContextFile,
    currentDocument: s.currentDocument,
  }));

  const recentDocs = useMemo(
    () =>
      allRecents.filter(
        (item) =>
          item.feature === UserRecentFeature.Docs &&
          item.objectRef !== currentDocument?._id,
      ),
    [allRecents, currentDocument],
  );

  if (!recentDocs.length)
    return (
      <Stack alignItems="center" py={0.75}>
        <Typography variant="caption" color="text.secondary">
          {translate('search.labels.no_recent_docs')}
        </Typography>
      </Stack>
    );

  return (
    <>
      {recentDocs.map((recent) => (
        <MenuItem
          key={recent.url}
          onClick={(e) => {
            e.stopPropagation();
            toggle(ContextItemType.RECENT, recent);
          }}
        >
          <ListItemIcon>
            <NavRecentItemIcon recent={recent} />
          </ListItemIcon>
          <ListItemText>{recent.title}</ListItemText>
          {hasContextFile(ContextItemType.RECENT, recent) && (
            <Iconify icon="tabler:check" color="success.main" />
          )}
        </MenuItem>
      ))}
    </>
  );
};
